// imports the React Javascript Library
import React, { useState } from "react";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import Fab from "@material-ui/core/Fab";
// Search
import IconButton from "@material-ui/core/IconButton";
import { useStyles } from "../../../assets/styles";
import { isNotAnImage, imageHasSizeHigherThan250kb } from "../../../utils/imageCheck";

export default function CustomFile(props) {
	const { handleChange, value = { image: "", preview: "" }, data } = props;
	const { label, id } = data;

	const [image, setImage] = useState(value);
	const classes = useStyles();

	const handleImageSelector = (e) => {
		const { files } = e.target;
		const image = files[0];
		if (isNotAnImage(image) || imageHasSizeHigherThan250kb(image)) {
			alert("La imagen debe ser JPG, y menor de 250kb");
			return;
		}
		const newValue = { image, preview: URL.createObjectURL(image) };
		setImage(newValue);
		const syntheticEvent = {
			target: {
				name: id,
				value: newValue,
			},
		};
		handleChange(syntheticEvent);
	};
	const isImageURL = typeof value === "string";
	return (
		<div
			style={{
				padding: "1em",
				backgroundImage: `url(${isImageURL ? value : image.preview})`,
				backgroundRepeat: "no-repeat",
				backgroundPosition: "center",
			}}
		>
			<input
				accept="image/*"
				className={classes.inputFile}
				id="icon-button-file"
				type="file"
				onChange={handleImageSelector}
			/>
			<Fab>
				<label htmlFor="icon-button-file">
					<IconButton color="primary" aria-label="upload picture" component="span">
						<AddPhotoAlternateIcon />
					</IconButton>
				</label>
			</Fab>
		</div>
	);
}
